import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _class2, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { observable, reaction, action, computed } from 'mobx';
import { task } from 'mobx-task';
import { validationContext, required } from 'validx';
import { Model } from 'libx';
import { isMatch } from 'lodash';
import { match } from '../../../utils/patternMatchUtil';
import ConfirmDialogState from '../../../components/ConfirmDialog/ConfirmDialogState';
import Document from '../../Document';
import { populateValidationContextFromError, extractMessageFromError, ignore404 } from '../../../utils/errorUtil';
var DocumentInspectorState = (_dec4 = action.bound, _dec5 = action.bound, _dec6 = action.bound, _dec7 = task.resolved, _dec8 = task.resolved, _dec9 = task.resolved, _dec10 = task.resolved, _dec11 = task.resolved, _dec12 = task.resolved, _dec13 = action.bound, _dec14 = action.bound, _class2 = /*#__PURE__*/function (_Model) {
  function DocumentInspectorState(attrs, opts) {
    var _this2;
    _classCallCheck(this, DocumentInspectorState);
    _this2 = _callSuper(this, DocumentInspectorState, arguments);
    _this2.viewType = 'DocumentInspector';
    _initializerDefineProperty(_this2, "viewTab", _descriptor4, _this2);
    _initializerDefineProperty(_this2, "tags", _descriptor5, _this2);
    _initializerDefineProperty(_this2, "title", _descriptor6, _this2);
    _initializerDefineProperty(_this2, "description", _descriptor7, _this2);
    _initializerDefineProperty(_this2, "archived", _descriptor8, _this2);
    _initializerDefineProperty(_this2, "snapshot", _descriptor9, _this2);
    _initializerDefineProperty(_this2, "documentType", _descriptor10, _this2);
    _this2.validation = validationContext(_this2, Document.validationRules);
    _this2.save = _this2.save.bind(_this2);
    _this2.replaceContents = _this2.replaceContents.bind(_this2);
    _this2.remove = _this2.remove.bind(_this2);
    _this2.close = opts.close;
    _this2.performDelete = opts.performDelete;
    _this2.newVersionPrompt = new NewVersionPrompt();
    _this2.confirmAccessDelete = new ConfirmDialogState();
    _this2.confirmDocumentDelete = new ConfirmDialogState();
    return _this2;
  }
  _inherits(DocumentInspectorState, _Model);
  return _createClass(DocumentInspectorState, [{
    key: "viewTitle",
    get: function get() {
      return this.document.title;
    }
  }, {
    key: "canRemove",
    get: function get() {
      return this.viewType === 'DocumentInspector' && this.document.canEdit;
    }
  }, {
    key: "canChangeDocumentType",
    get: function get() {
      var _this$document$docume;
      return !((_this$document$docume = this.document.documentType) !== null && _this$document$docume !== void 0 && _this$document$docume.id);
    }
  }, {
    key: "viewLabel",
    get: function get() {
      return this.document.canEdit ? '' : 'Read Only';
    }
  }, {
    key: "viewTabs",
    get: function get() {
      return [{
        id: 'Info',
        title: 'Info',
        tooltip: 'General info pertaining to the document.'
      }, this.document.canManageAccess && {
        id: 'Access',
        title: 'Permissions',
        tooltip: 'Document access & edit permissions.'
      }, {
        id: 'History',
        title: 'Versions',
        tooltip: 'Document version history.'
      }].filter(function (x) {
        return x;
      });
    }
  }, {
    key: "saveEnabled",
    get: function get() {
      return isMatch(this.snapshot, {
        title: this.title,
        description: this.description,
        tags: this.tags,
        documentType: this.documentType
      });
    }
  }, {
    key: "activate",
    value: function activate() {
      var _this3 = this;
      // Whenever the source changes, update the info form.
      this.disposeDocumentObserver = reaction(function () {
        return _objectSpread(_objectSpread({}, _this3.document.pick(['title', 'description', 'archived', 'documentType'])), {}, {
          tags: _this3.document.tags.map(function (x) {
            return x.id;
          })
        });
      }, this.set, {
        fireImmediately: true
      });
      this.fetchAccessInfo();
      var _this$document = this.document,
        title = _this$document.title,
        description = _this$document.description,
        tags = _this$document.tags,
        documentType = _this$document.documentType;
      this.snapshot = {
        title: title,
        description: description,
        tags: tags,
        documentType: documentType
      };
      this.setDocumentType(documentType);
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      if (this.disposeDocumentObserver) {
        this.disposeDocumentObserver();
      }
    }
  }, {
    key: "setTags",
    value: function setTags(tags) {
      this.tags = tags;
    }
  }, {
    key: "setDocumentType",
    value: function setDocumentType(documentType) {
      this.documentType = documentType;
    }
  }, {
    key: "busy",
    get: function get() {
      return [this.replaceContents, this.revertToVersion, this.save, this.fetchAccessInfo, this.changeAccessPermission].some(function (x) {
        return x.pending;
      });
    }
  }, {
    key: "replaceContents",
    value: function () {
      var _replaceContents = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(files) {
        var newVersionInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.newVersionPrompt.prompt({
                text: "By uploading a new version of this document you\u2019ll be replacing the old document. Don't worry, you can always revert back.",
                button: 'Upload'
              });
            case 2:
              newVersionInfo = _context.sent;
              if (newVersionInfo) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              _context.prev = 5;
              _context.next = 8;
              return this.rootStore.documentVersionStore.createVersion({
                document_id: this.document.id,
                message: newVersionInfo.message,
                action: {
                  files: files,
                  type: 'ReplaceContents'
                }
              });
            case 8:
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](5);
              return _context.abrupt("return", this.showAndThrow(_context.t0));
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[5, 10]]);
      }));
      function replaceContents(_x) {
        return _replaceContents.apply(this, arguments);
      }
      return replaceContents;
    }()
  }, {
    key: "revertToVersion",
    value: function () {
      var _revertToVersion = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(oldVersion) {
        var newVersionInfo;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.newVersionPrompt.prompt({
                message: "Revert to version: ".concat(oldVersion.message),
                text: "Reverting creates a new version with the contents of the old one.",
                button: 'Revert'
              });
            case 2:
              newVersionInfo = _context2.sent;
              if (newVersionInfo) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              _context2.next = 7;
              return this.rootStore.documentVersionStore.createVersion({
                document_id: this.document.id,
                message: newVersionInfo.message,
                action: {
                  version_id: oldVersion.id,
                  type: 'RevertToVersion'
                }
              }).catch(this.showAndThrow);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function revertToVersion(_x2) {
        return _revertToVersion.apply(this, arguments);
      }
      return revertToVersion;
    }()
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var valid, documentType, document, _document$documentTyp;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              valid = this.validation.reset().validate().isValid;
              if (valid) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              documentType = this.documentType;
              document = this.document;
              _context3.prev = 5;
              _context3.next = 8;
              return this.rootStore.documentStore.updateDocument(this.document.id, {
                title: this.title,
                description: this.description,
                tags: this.tags.slice()
              });
            case 8:
              if (!(documentType !== null && documentType !== void 0 && documentType.id && !((_document$documentTyp = document.documentType) !== null && _document$documentTyp !== void 0 && _document$documentTyp.id))) {
                _context3.next = 11;
                break;
              }
              _context3.next = 11;
              return this.rootStore.documentStore.assignType(document.id, documentType.id);
            case 11:
              _context3.next = 18;
              break;
            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](5);
              populateValidationContextFromError(this.validation, _context3.t0);
              this.rootStore.flashMessageStore.create({
                type: 'error',
                message: extractMessageFromError(_context3.t0)
              });
              throw _context3.t0;
            case 18:
              this.activate();
            case 19:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[5, 13]]);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }()
  }, {
    key: "fetchAccessInfo",
    value: function () {
      var _fetchAccessInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this4 = this;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return Promise.all(this.document.accesses.map(function (access) {
                return match(access.type, _defineProperty({
                  Job: function Job() {
                    return _this4.rootStore.jobStore.getJob(access.jobId).catch(ignore404);
                  }
                }, match.DEFAULT, function () {
                  return Promise.resolve(null);
                }));
              })).catch(this.showAndThrow);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function fetchAccessInfo() {
        return _fetchAccessInfo.apply(this, arguments);
      }
      return fetchAccessInfo;
    }()
  }, {
    key: "changeAccessPermission",
    value: function () {
      var _changeAccessPermission = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(access, newPermission) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.rootStore.documentAccessStore.updateAccess(access.id, {
                edit_permission: newPermission
              });
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function changeAccessPermission(_x3, _x4) {
        return _changeAccessPermission.apply(this, arguments);
      }
      return changeAccessPermission;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.confirmDocumentDelete.show();
            case 2:
              if (_context6.sent) {
                _context6.next = 4;
                break;
              }
              return _context6.abrupt("return");
            case 4:
              _context6.prev = 4;
              if (!this.performDelete) {
                _context6.next = 10;
                break;
              }
              _context6.next = 8;
              return this.performDelete(this.document);
            case 8:
              _context6.next = 12;
              break;
            case 10:
              _context6.next = 12;
              return this.rootStore.documentStore.archiveDocument(this.document.id);
            case 12:
              this.close();
              _context6.next = 20;
              break;
            case 15:
              _context6.prev = 15;
              _context6.t0 = _context6["catch"](4);
              populateValidationContextFromError(this.validation, _context6.t0);
              this.rootStore.flashMessageStore.create({
                type: 'error',
                message: extractMessageFromError(_context6.t0)
              });
              throw _context6.t0;
            case 20:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[4, 15]]);
      }));
      function remove() {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
  }, {
    key: "deleteAccess",
    value: function () {
      var _deleteAccess = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(access) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.confirmAccessDelete.show();
            case 2:
              if (_context7.sent) {
                _context7.next = 4;
                break;
              }
              return _context7.abrupt("return");
            case 4:
              _context7.next = 6;
              return this.rootStore.documentAccessStore.deleteAccess(access.id);
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function deleteAccess(_x5) {
        return _deleteAccess.apply(this, arguments);
      }
      return deleteAccess;
    }()
  }, {
    key: "download",
    value: function download(version, file) {
      this.rootStore.documentStore.download(this.document, false, version, file);
    }
  }, {
    key: "showAndThrow",
    value: function showAndThrow(error) {
      this.rootStore.flashMessageStore.create({
        type: 'error',
        message: extractMessageFromError(error)
      });
      throw error;
    }
  }]);
}(Model), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "viewTab", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'Info';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "tags", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "title", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "description", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "archived", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "snapshot", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "documentType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "viewTitle", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "viewTitle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "canRemove", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "canRemove"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "canChangeDocumentType", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "canChangeDocumentType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "viewLabel", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "viewLabel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "viewTabs", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "viewTabs"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "saveEnabled", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "saveEnabled"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "activate", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "activate"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setTags", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "setTags"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setDocumentType", [_dec6], Object.getOwnPropertyDescriptor(_class2.prototype, "setDocumentType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "busy", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "busy"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "replaceContents", [_dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "replaceContents"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "revertToVersion", [_dec8], Object.getOwnPropertyDescriptor(_class2.prototype, "revertToVersion"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "save", [_dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "save"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "fetchAccessInfo", [task], Object.getOwnPropertyDescriptor(_class2.prototype, "fetchAccessInfo"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeAccessPermission", [_dec10], Object.getOwnPropertyDescriptor(_class2.prototype, "changeAccessPermission"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "remove", [_dec11], Object.getOwnPropertyDescriptor(_class2.prototype, "remove"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deleteAccess", [_dec12], Object.getOwnPropertyDescriptor(_class2.prototype, "deleteAccess"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "download", [_dec13], Object.getOwnPropertyDescriptor(_class2.prototype, "download"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showAndThrow", [_dec14], Object.getOwnPropertyDescriptor(_class2.prototype, "showAndThrow"), _class2.prototype), _class2);
export { DocumentInspectorState as default };
var NewVersionPrompt = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _class = /*#__PURE__*/function () {
  function NewVersionPrompt() {
    _classCallCheck(this, NewVersionPrompt);
    _initializerDefineProperty(this, "message", _descriptor, this);
    _initializerDefineProperty(this, "text", _descriptor2, this);
    _initializerDefineProperty(this, "showing", _descriptor3, this);
    this.validation = validationContext(this, {
      message: [required('Message is required.')]
    });
  }
  return _createClass(NewVersionPrompt, [{
    key: "close",
    value: function close() {
      this.showing = false;
      this.resolve(null);
    }
  }, {
    key: "prompt",
    value: function prompt(props) {
      var _this = this;
      this.message = '';
      this.showing = true;
      this.validation.reset();
      Object.assign(this, props);
      // The trick is to save the resolver,
      // then invoke it once we've collected the info.
      return new Promise(function (resolve) {
        _this.setResolve(resolve);
      });
    }
  }, {
    key: "submit",
    value: function submit() {
      if (this.validation.reset().validate().isValid === false) {
        return;
      }
      this.showing = false;
      this.resolve({
        message: this.message
      });
    }

    /**
     * Resolves the current promise if any, and sets the new resolver.
     * @param {Function} resolve
     */
  }, {
    key: "setResolve",
    value: function setResolve(resolve) {
      this.resolve(null);
      this._resolve = resolve;
    }
  }, {
    key: "resolve",
    value: function resolve(data) {
      if (this._resolve) {
        this._resolve(data);
      }
      delete this._resolve;
    }
  }]);
}(), _descriptor = _applyDecoratedDescriptor(_class.prototype, "message", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "text", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "showing", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "close", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "prompt", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "prompt"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submit", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "submit"), _class.prototype), _class);
//# sourceMappingURL=DocumentInspectorState.js.map
